import { Usuario } from "../despacho/Usuario";

export interface NotificacionUsuario{
    id: string;
    usuario: Usuario;
    fechaHora: string;
    fechaHoraVisualizacion: string;
    fechaHoraLectura: string;
    titulo: string;
    mensaje: string;
  }